import { render } from "./HelloWorld.vue?vue&type=template&id=a48034f0&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=a48034f0&scoped=true&lang=scss"

import exportComponent from "/Users/jenni/Documents/Labbet/boliden-photobooth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a48034f0"]])

export default __exports__